import React, { useMemo } from "react";
import styled from "styled-components";
import OD15Module from "../modules/OD15Module";
import { CardTitle, PanelCard } from "../shared/styles";

const SessionRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const CoachAvatarStack = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const CoachAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.altBackground};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.heading};
  border: 2px solid ${({ theme }) => theme.colors.primaryBackground};
  margin-left: ${({ first }) => (first ? "0" : "-25px")};
  position: relative;
  z-index: ${({ index, total }) => total - index};
  transition: transform 0.2s ease, z-index 0s;
  cursor: default;
  &:not(:first-child):hover {
    z-index: 999;
  }
`;

const CoachAvatarImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const BoldCardTitle = styled(CardTitle)`
  font-size: 16px;
  font-weight: 700;
`;

const COACH_PHOTOS = [
  "https://gracepapers-content-prod.s3.ap-southeast-2.amazonaws.com/avatars/user/3168/Tegan.png",
  "https://gracepapers-content-prod.s3.ap-southeast-2.amazonaws.com/avatars/user/269/Amanda_circle.jpg",
  "https://gracepapers-content-prod.s3.ap-southeast-2.amazonaws.com/avatars/user/1002433/Suzanne.png",
  "https://gracepapers-content-prod.s3.ap-southeast-2.amazonaws.com/avatars/user/15294/Michelle.png",
  "https://gracepapers-content-prod.s3.ap-southeast-2.amazonaws.com/avatars/user/1002439/Dickson.png",
];

function StackedAvatars() {
  const photos = useMemo(() => {
    const shuffled = [...COACH_PHOTOS].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 3);
  }, []);

  return (
    <CoachAvatarStack>
      {photos.map((url, i) => (
        <CoachAvatar key={url} first={i === 0} index={i} total={photos.length}>
          <CoachAvatarImg src={url} alt="Coach" />
        </CoachAvatar>
      ))}
    </CoachAvatarStack>
  );
}

export default function Od15Card({ data, onBookingAction, od15BookingUrl }) {
  const isBooked = data?.sessions?.length > 0;
  if (isBooked) {
    return (
      <>
        <OD15Module
          data={data}
          onBookingAction={onBookingAction}
          bookingUrl={od15BookingUrl}
        />
      </>
    );
  }
  return (
    <>
      <PanelCard>
        <SessionRow>
          <StackedAvatars />
          <BoldCardTitle>CoachConnect 15</BoldCardTitle>
        </SessionRow>
        <OD15Module
          data={data}
          onBookingAction={onBookingAction}
          bookingUrl={od15BookingUrl}
        />
      </PanelCard>
    </>
  );
}
